import React, { useMemo } from 'react';
import MemberPicker from './MemberPicker';
import { input as inputStyle, select as selectStyle, btnGhost, btnSm } from './trackUi';

/**
 * value: { boardId, assigneeId, initiatorId, status, q, starred, includeDone }
 * show: 要顯示的篩選項（預設全部）
 */
export default function TaskFilterBar({ boards, members, value, onChange, show = {}, children }) {
  const s = { board: true, assignee: true, initiator: true, status: true, q: true, starred: true, includeDone: true, ...show };
  const set = (patch) => onChange({ ...value, ...patch });
  const statusOptions = useMemo(() => {
    const src = value.boardId ? (boards || []).filter((b) => b.id === Number(value.boardId)) : (boards || []);
    const seen = new Map();
    src.forEach((b) => b.statuses.forEach((st) => { if (!seen.has(st.key)) seen.set(st.key, st); }));
    return [...seen.values()];
  }, [boards, value.boardId]);
  const hasFilter = value.boardId || value.assigneeId || value.initiatorId || value.status || value.q || value.starred || value.includeDone;

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
      {s.board && (
        <select style={selectStyle} value={value.boardId || ''} onChange={(e) => set({ boardId: e.target.value ? Number(e.target.value) : null, status: '' })}>
          <option value="">全部看板</option>
          {(boards || []).filter((b) => b.isActive).map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
      )}
      {s.assignee && (
        <MemberPicker members={members} value={value.assigneeId} onChange={(v) => set({ assigneeId: v })} placeholder="全部執行人" />
      )}
      {s.initiator && (
        <MemberPicker members={members} value={value.initiatorId} onChange={(v) => set({ initiatorId: v })} placeholder="全部發起人" />
      )}
      {s.status && (
        <select style={selectStyle} value={value.status || ''} onChange={(e) => set({ status: e.target.value })}>
          <option value="">全部狀態</option>
          {statusOptions.map((st) => <option key={st.key} value={st.key}>{st.label}</option>)}
        </select>
      )}
      {s.q && (
        <input
          style={{ ...inputStyle, width: 150 }}
          placeholder="搜尋編號／名稱"
          value={value.q || ''}
          onChange={(e) => set({ q: e.target.value })}
        />
      )}
      {s.starred && (
        <label style={{ fontSize: 13, display: 'inline-flex', gap: 4, alignItems: 'center' }}>
          <input type="checkbox" checked={!!value.starred} onChange={(e) => set({ starred: e.target.checked })} />
          只看星號
        </label>
      )}
      {s.includeDone && (
        <label style={{ fontSize: 13, display: 'inline-flex', gap: 4, alignItems: 'center' }}>
          <input type="checkbox" checked={!!value.includeDone} onChange={(e) => set({ includeDone: e.target.checked })} />
          含已完成
        </label>
      )}
      {hasFilter && (
        <button
          type="button"
          style={{ ...btnGhost, ...btnSm }}
          onClick={() => onChange({ boardId: s.board ? null : value.boardId, assigneeId: null, initiatorId: null, status: '', q: '', starred: false, includeDone: false })}
        >
          清除
        </button>
      )}
      {children}
    </div>
  );
}

export function filtersToParams(v) {
  const p = {};
  if (v.boardId) p.boardId = v.boardId;
  if (v.assigneeId) p.assigneeId = v.assigneeId;
  if (v.initiatorId) p.initiatorId = v.initiatorId;
  if (v.status) p.status = v.status;
  if (v.q) p.q = v.q;
  if (v.starred) p.starred = 1;
  if (v.includeDone) p.includeDone = 1;
  return p;
}
